<template>
  <div class="question-title">
    <h1 class="title" :class="{ 'title--with-subtitle': subtitle }">
      {{ questionTitle }}
    </h1>
    <!-- TODO add subTitle component here instead of class -->
    <h2 v-if="subtitle" class="subtitle">
      {{ subtitle }}
    </h2>
  </div>
</template>

<script>
export default {
  name: 'QuestionTitle',
  props: {
    title: {
      type: [String, Object],
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    questionTitle () {
      if (typeof this.title === 'string') {
        return this.title
      }

      const isExisting = this.$store.getters.isExisting

      if (isExisting) {
        return this.title.existing
      } else {
        return this.title.nonExisting
      }
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  color: $question-title-color;
  font-weight: $question-title-font-weight;
  text-align: left;
  max-width: 288px;
  font-size: 20px;
  line-height: 26px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: $spacing-32;

  @media (min-width: 720px) {
    text-align: center;
    font-size: 28px;
    letter-spacing: -0.7px;
    line-height: 36px;
    max-width: 513px;
    margin-bottom: $spacing-24;
  }

  @media (min-width: 421px) and (max-width: 719px) {
    max-width: 340px;
  }

  &--with-subtitle {
    margin-bottom: $spacing-10;
    @media (min-width: 720px) {
      margin-bottom: $spacing-10;
    }
  }
}

.subtitle {
  color: $question-subtitle-color;
  opacity: 0.8;
  letter-spacing: -0.64px;
  font-weight: 400;
  margin: $spacing-0 auto $spacing-20;
  font-size: 15px;
  line-height: 16px;
  max-width: 288px;
  text-align: left;

  @media (min-width: 421px) and (max-width: 719px) {
    max-width: 340px;
  }

  @media (min-width: 720px) {
    max-width: 525px;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
  }
}
</style>
